import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobEmailTemplate.Delete.IRequest;
type Response = Api.Core.ClaimJobEmailTemplate.Delete.IResponse;
type Headers = Api.Core.ClaimJobEmailTemplate.Delete.IHeaders;
const url = '/api/Management/ClaimJobEmailTemplate/:id';
export default async function claimJobEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
